import React from "react";
import { Button, Typography } from "antd";

import "./style.scss";

const { Title } = Typography;

const ReportsPage = () => {
  return (
    <div>
      <Title level={3}>Reports / Reportes</Title>

      <div className="buttons-section">
        <div>
          <Button type="primary">
            <a
              rel="noreferrer"
              target="_blank"
              href={`${process.env.REACT_APP_API_HOST.replace(
                "api/v1",
                ""
              )}download/all_survey`}
            >
              Answers / Respuestas
            </a>
          </Button>
        </div>
        <div>
          <Button type="primary">
            <a
              rel="noreferrer"
              target="_blank"
              href={`${process.env.REACT_APP_API_HOST.replace(
                "api/v1",
                ""
              )}download/all_politics`}
            >
              Policies / Politicas
            </a>
          </Button>
        </div>
        <div>
          <Button type="primary">
            <a
              rel="noreferrer"
              target="_blank"
              href={`${process.env.REACT_APP_API_HOST.replace(
                "api/v1",
                ""
              )}download/all_actors`}
            >
              Policies - Actors / Politicas - Actores{" "}
            </a>
          </Button>
        </div>
        <div>
          <Button type="primary">
            <a
              rel="noreferrer"
              target="_blank"
              href={`${process.env.REACT_APP_API_HOST.replace(
                "api/v1",
                ""
              )}download/all_resources`}
            >
              Policies - Resources / Politicas - Recursos
            </a>
          </Button>
        </div>
      </div>

      <iframe
        width="100%"
        height="800"
        src="https://datastudio.google.com/embed/reporting/0841f905-7821-4ffc-bfb5-5130e81e9ef1/page/p_5joekggonc"
        frameborder="0"
        style={{ border: 0 }}
        allowfullscreen
        title={"Google datastudio report"}
      ></iframe>
    </div>
  );
};

export default ReportsPage;
